<template>
  <StandardDropdown
    v-bind="$attrs"
    theme="blue"
  />
</template>

<script>
import StandardDropdown from './StandardDropdown.vue'

export default {
  name: 'StandardBlueDropdown',
  components: {
    StandardDropdown
  },
  inheritAttrs: false
}
</script>


